export default "__VITE_ASSET__ufNMhzQi__"